/* YYorrZ cookie consent bridge — popup timing is controlled by the Liquid snippets */
(function(){
  'use strict';

  var cookie=document.getElementById('CookieBanner');
  if(!cookie)return;

  function isThemePreview(){
    try{
      if(window.Shopify&&Shopify.designMode)return true;
      var params=new URLSearchParams(window.location.search);
      return params.has('preview_theme_id')||params.has('_theme_id');
    }catch(e){return false}
  }

  function setShopifyConsent(allow){
    if(isThemePreview())return;
    var consent={analytics:allow,marketing:allow,preferences:allow};

    function apply(){
      try{
        var api=window.Shopify&&Shopify.customerPrivacy;
        if(api&&typeof api.setTrackingConsent==='function'){
          api.setTrackingConsent(consent,function(){});
        }
      }catch(e){}
    }

    try{
      if(window.Shopify&&Shopify.customerPrivacy&&typeof Shopify.customerPrivacy.setTrackingConsent==='function'){
        apply();
      }else if(window.Shopify&&typeof Shopify.loadFeatures==='function'){
        Shopify.loadFeatures(
          [{name:'consent-tracking-api',version:'0.1'}],
          function(error){if(!error)apply();}
        );
      }
    }catch(e){}
  }

  var accept=cookie.querySelector('[data-cookie-accept]');
  var decline=cookie.querySelector('[data-cookie-decline]');

  if(accept)accept.addEventListener('click',function(){setShopifyConsent(true);});
  if(decline)decline.addEventListener('click',function(){setShopifyConsent(false);});
})();
